const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  tabsContainer: {
    display: 'flex',
    backgroundColor: '#F4F6F8',
    borderRadius: 12,
    padding: 8,
    gap: 12,
  },
  tab: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '12px 16px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#637381',
    borderRadius: 8,
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
      color: '#002E47',
    },
  },
  tabActive: {
    color: '#002E47',
    backgroundColor: '#fff',
  },
  tabIcon: {
    width: 18,
    height: 18,
  },
  inputRow: {
    display: 'flex',
    gap: 16,
  },
  inputField: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  inputFieldFull: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  charCount: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  input: {},
  heading: {
    padding: '8px 0',
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
    fontFamily: 'Inter',
  },
  badgeStyleHeading: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
  tipMessage: {
    fontWeight: 400,
    fontSize: '12px !important',
    color: '#637381',
    textAlign: 'center',
    fontFamily: 'Inter',
  },
  settingDrawerOpenSpan: {
    fontWeight: 400,
    fontSize: '12px !important',
    color: '#015FFB',
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  charCountText: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#919EAB',
  },
  modal: {
    display: 'flex !important',
  },
  modalContent: {
    height: '437px',
    backgroundColor: '#fff',
    margin: 'auto',
    zIndex: 1300,
    borderRadius: '16px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    '&:focus': {
      outline: 'none!important',
    },
  },
  premiumBadges: {
    display: 'flex',
    height: '20px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  uploadSectionTitle: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#002E47',
    fontFamily: 'Inter',
    lineHeight: '150%',
  },
  uploadContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  uploadDropzone: {
    width: 120,
    minWidth: 120,
    height: 120,
    border: '1.2px dashed #E5E7EB',
    borderRadius: 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#F4F6F8',
    gap: 8,
    '&:hover': {
      borderColor: '#015FFB',
    },
  },
  uploadDropzoneWithImage: {
    width: 120,
    minWidth: 120,
    height: 120,
    border: '1.2px dashed #E5E7EB',
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#fff',
    overflow: 'hidden',
    position: 'relative',
    '&:hover': {
      borderColor: '#015FFB',
    },
  },
  uploadedImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  uploadIcon: {
    color: '#637381',
    fontSize: 28,
  },
  uploadDropzoneText: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#637381',
    fontFamily: 'Inter',
  },
  uploadInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  uploadInfoTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
    fontFamily: 'Inter',
    lineHeight: '150%',
  },
  uploadInfoText: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#919EAB',
    fontFamily: 'Inter',
    lineHeight: '150%',
  },
  customBadgeGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 8,
  },
  customBadgeItem: {
    width: 72,
    height: 72,
    borderRadius: 8,
    overflow: 'hidden',
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: '#fff',
    '&:hover $customBadgeDeleteBtn': {
      opacity: 1,
    },
  },
  customBadgeImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  customBadgeDeleteBtn: {
    position: 'absolute',
    top: 6,
    right: 6,
    width: 32,
    height: 32,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 0,
    boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
})

export default styles
